/**
 * Vale gás — obrigatoriedade do telefone do cliente por mercado e data (CPF permanece opcional).
 *
 * Cada lote tem o próprio ano (`VALE_GAS_MANDATORY_YEAR_*`). Deixe **2028** em produção até o
 * go-live daquela data; aí troque só a constante daquele lote para **2026** e publique de novo.
 *
 * O texto do aviso “A partir do dia …” usa sempre o ano abaixo (**2026**), sem exibir 2028 ao usuário.
 */
/** Ano exibido em “A partir do dia DD/MM/AAAA…” (comunicação; independente do ano técnico acima). */
const VALE_GAS_MANDATORY_NOTICE_DISPLAY_YEAR = 2026;

export const VALE_GAS_MANDATORY_YEAR_APR27 = 2026;
export const VALE_GAS_MANDATORY_YEAR_MAY04 = 2026;
export const VALE_GAS_MANDATORY_YEAR_MAY11 = 2028;
export const VALE_GAS_MANDATORY_YEAR_MAY18 = 2028;

/** Mercados — 27/04 (ano = VALE_GAS_MANDATORY_YEAR_APR27) */
const MARKETS_MANDATORY_FROM_2026_04_27 = ['ceara', 'centro oeste', 'para'];

/** Interior SP, Sudeste — 04/05 */
const MARKETS_MANDATORY_FROM_2026_05_04 = [
  'interior sp',
  'interior de sp',
  'sudeste',
];

/** Grande SP, Bahia — 11/05 */
const MARKETS_MANDATORY_FROM_2026_05_11 = [
  'grande sp',
  'grande sao paulo',
  'bahia',
];

/** Sul — 18/05 */
const MARKETS_MANDATORY_FROM_2026_05_18 = ['sul'];

function startOfLocalDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * @param {string | null | undefined} raw
 * @returns {string}
 */
export function normalizeMarketName(raw) {
  if (raw == null || typeof raw !== 'string') return '';
  return raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ');
}

/**
 * @param {string} normalized resultado de normalizeMarketName
 * @returns {Date | null} null = mercado fora do rollout (campos opcionais, sem aviso)
 */
function mandatoryStartDateForNormalizedMarket(normalized) {
  if (!normalized) return null;
  if (MARKETS_MANDATORY_FROM_2026_04_27.includes(normalized)) {
    return new Date(VALE_GAS_MANDATORY_YEAR_APR27, 3, 27);
  }
  if (MARKETS_MANDATORY_FROM_2026_05_04.includes(normalized)) {
    return new Date(VALE_GAS_MANDATORY_YEAR_MAY04, 4, 4);
  }
  if (MARKETS_MANDATORY_FROM_2026_05_11.includes(normalized)) {
    return new Date(VALE_GAS_MANDATORY_YEAR_MAY11, 4, 11);
  }
  if (MARKETS_MANDATORY_FROM_2026_05_18.includes(normalized)) {
    return new Date(VALE_GAS_MANDATORY_YEAR_MAY18, 4, 18);
  }
  return null;
}

/** Dia/mês vêm do mesmo lote que a data técnica; o ano na tela é sempre o “comunicado”. */
function formatNoticeDayMonthYearPtBr(d) {
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${VALE_GAS_MANDATORY_NOTICE_DISPLAY_YEAR}`;
}

/**
 * @param {string | null | undefined} marketRaw valor de `localStorage.getItem('market')`
 */
/** Após a data do lote: celular obrigatório; CPF continua opcional. */
export function isValeGasConsumerPhoneRequired(marketRaw) {
  const normalized = normalizeMarketName(marketRaw);
  const start = mandatoryStartDateForNormalizedMarket(normalized);
  if (start == null) return false;
  const today = startOfLocalDay(new Date());
  return today >= startOfLocalDay(start);
}

export const VALE_GAS_MANDATORY_FIELDS_MESSAGE =
  'Importante! O preenchimento do campo celular do cliente é obrigatório.';

/**
 * Aviso na validação do vale: data futura (só telefone obrigatório), ou mensagem fixa quando já vigente.
 * Mercado fora das listas: sem aviso (mantém opcional).
 * @param {string | null | undefined} marketRaw
 * @returns {
 *   | { type: 'upcoming'; lead: string; date: string; tail: string }
 *   | { type: 'mandatory'; message: string }
 *   | null
 * }
 */
export function getValeGasConsumerFieldsNotice(marketRaw) {
  const normalized = normalizeMarketName(marketRaw);
  const start = mandatoryStartDateForNormalizedMarket(normalized);
  if (start == null) return null;

  if (isValeGasConsumerPhoneRequired(marketRaw)) {
    return { type: 'mandatory', message: VALE_GAS_MANDATORY_FIELDS_MESSAGE };
  }

  const tail =
    ' será obrigatório o preenchimento dos campos celular e CPF do cliente.';
  return {
    type: 'upcoming',
    lead: 'Importante! A partir do dia ',
    date: formatNoticeDayMonthYearPtBr(start),
    tail,
  };
}
